// extracted by mini-css-extract-plugin
export var numberInputContainer = "_52-0";
export var startPickingButton = "_52-1";